import { render, staticRenderFns } from "./ClassCard.vue?vue&type=template&id=1974d9ea&scoped=true&"
import script from "./ClassCard.vue?vue&type=script&lang=ts&"
export * from "./ClassCard.vue?vue&type=script&lang=ts&"
import style0 from "./ClassCard.vue?vue&type=style&index=0&id=1974d9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974d9ea",
  null
  
)

export default component.exports